// project-imports
import yoraMenu from './yora';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [yoraMenu]
};

export default menuItems;
